/* tslint:disable */
/* eslint-disable */
/**
 * IbanOplata.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { IbanInvoicePaymentAddCommand } from '../models';
// @ts-ignore
import type { IbanInvoicePaymentCreateResponseDto } from '../models';
// @ts-ignore
import type { IbanInvoicePaymentResponseDto } from '../models';
// @ts-ignore
import type { IbanInvoicePaymentUpdateStatusCommand } from '../models';
// @ts-ignore
import type { ProblemDetails } from '../models';
/**
 * IbanInvoicePaymentApi - axios parameter creator
 * @export
 */
export const IbanInvoicePaymentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {IbanInvoicePaymentAddCommand} [ibanInvoicePaymentAddCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIbanInvoicePaymentPost: async (ibanInvoicePaymentAddCommand?: IbanInvoicePaymentAddCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/iban-invoice-payment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ibanInvoicePaymentAddCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {IbanInvoicePaymentUpdateStatusCommand} [ibanInvoicePaymentUpdateStatusCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIbanInvoicePaymentStatusPut: async (ibanInvoicePaymentUpdateStatusCommand?: IbanInvoicePaymentUpdateStatusCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/iban-invoice-payment/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ibanInvoicePaymentUpdateStatusCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IbanInvoicePaymentApi - functional programming interface
 * @export
 */
export const IbanInvoicePaymentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IbanInvoicePaymentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {IbanInvoicePaymentAddCommand} [ibanInvoicePaymentAddCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIbanInvoicePaymentPost(ibanInvoicePaymentAddCommand?: IbanInvoicePaymentAddCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IbanInvoicePaymentCreateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIbanInvoicePaymentPost(ibanInvoicePaymentAddCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IbanInvoicePaymentApi.apiIbanInvoicePaymentPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {IbanInvoicePaymentUpdateStatusCommand} [ibanInvoicePaymentUpdateStatusCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIbanInvoicePaymentStatusPut(ibanInvoicePaymentUpdateStatusCommand?: IbanInvoicePaymentUpdateStatusCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IbanInvoicePaymentResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIbanInvoicePaymentStatusPut(ibanInvoicePaymentUpdateStatusCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IbanInvoicePaymentApi.apiIbanInvoicePaymentStatusPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * IbanInvoicePaymentApi - factory interface
 * @export
 */
export const IbanInvoicePaymentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IbanInvoicePaymentApiFp(configuration)
    return {
        /**
         * 
         * @param {IbanInvoicePaymentAddCommand} [ibanInvoicePaymentAddCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIbanInvoicePaymentPost(ibanInvoicePaymentAddCommand?: IbanInvoicePaymentAddCommand, options?: RawAxiosRequestConfig): AxiosPromise<IbanInvoicePaymentCreateResponseDto> {
            return localVarFp.apiIbanInvoicePaymentPost(ibanInvoicePaymentAddCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IbanInvoicePaymentUpdateStatusCommand} [ibanInvoicePaymentUpdateStatusCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIbanInvoicePaymentStatusPut(ibanInvoicePaymentUpdateStatusCommand?: IbanInvoicePaymentUpdateStatusCommand, options?: RawAxiosRequestConfig): AxiosPromise<IbanInvoicePaymentResponseDto> {
            return localVarFp.apiIbanInvoicePaymentStatusPut(ibanInvoicePaymentUpdateStatusCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IbanInvoicePaymentApi - object-oriented interface
 * @export
 * @class IbanInvoicePaymentApi
 * @extends {BaseAPI}
 */
export class IbanInvoicePaymentApi extends BaseAPI {
    /**
     * 
     * @param {IbanInvoicePaymentAddCommand} [ibanInvoicePaymentAddCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IbanInvoicePaymentApi
     */
    public apiIbanInvoicePaymentPost(ibanInvoicePaymentAddCommand?: IbanInvoicePaymentAddCommand, options?: RawAxiosRequestConfig) {
        return IbanInvoicePaymentApiFp(this.configuration).apiIbanInvoicePaymentPost(ibanInvoicePaymentAddCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IbanInvoicePaymentUpdateStatusCommand} [ibanInvoicePaymentUpdateStatusCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IbanInvoicePaymentApi
     */
    public apiIbanInvoicePaymentStatusPut(ibanInvoicePaymentUpdateStatusCommand?: IbanInvoicePaymentUpdateStatusCommand, options?: RawAxiosRequestConfig) {
        return IbanInvoicePaymentApiFp(this.configuration).apiIbanInvoicePaymentStatusPut(ibanInvoicePaymentUpdateStatusCommand, options).then((request) => request(this.axios, this.basePath));
    }
}

